import { useTranslation } from "react-i18next";
import { AboutUs } from "~/components/about-us-view/about-us";
import type { MetaFunction } from "@remix-run/node";

export const AboutUsMetaData: MetaFunction = ({ matches, data }) => {
  const parentsData = matches[0]?.data;
  const storeMetadata = parentsData?.storeMetadata;
  const enterpriseName = storeMetadata?.enterpriseName || "";
  const country = storeMetadata?.country || "";
  const city = storeMetadata?.city || "";
  const descriptionAboutUs = `${data?.descriptionAboutUs?.replace(
    "{{enterpriseName}}",
    enterpriseName,
  )} ${city} ${country}.`;
  return [
    { name: "charset", content: "utf-8" },
    { title: `Sobre ${enterpriseName} en ${country}` },
    { name: "description", content: descriptionAboutUs },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: enterpriseName },
    { name: "og:description", content: descriptionAboutUs },
  ];
};

const AboutUsContainer = () => {
  const { t } = useTranslation();

  return (
    <AboutUs
      breadcrumbs={[{ text: t("about_us_internal_page.breadcrumbs") }]}
    />
  );
};

export default AboutUsContainer;
